export const FORM_SELECTOR = '[data-submit-form]';
export const FORM_SUBMIT_FORCE = 'data-submit-form-force';
export const FORM_SUBMIT_IGNORED = 'data-submit-form-ignored';
export const HAS_SUBMIT_FORM = 'data-has-submit-form';
